<template>
  <div id="xmsq" class="publicMain">
    <el-row class="align-i-c">
      <div class="float-l" v-if="isqfxt">
        <div class="dy-flex align-i-c pt-5 min-wt-480 mr-30">
          <label style="width: 80px;">{{ $t("xmsq.queryFormsqxt") }}：</label>
          <ButtonBox
            :id="'wscx'"
            :plain="btncolor != 'cx'"
            :buttonData="getArgumentDetail('wscxbtn')"
            @click.native="getXmsqinfo('cx')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'wsbx'"
            :plain="btncolor != 'bx'"
            :buttonData="getArgumentDetail('wsbxbtn')"
            @click.native="getXmsqinfo('bx')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'wssb'"
            :plain="btncolor != 'sb'"
            :buttonData="getArgumentDetail('wssbbtn')"
            @click.native="getXmsqinfo('sb')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'yjkp'"
            :plain="btncolor != 'jp'"
            :buttonData="getArgumentDetail('yjkpbtn')"
            @click.native="getXmsqinfo('jp')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
        </div>
        <p class="color-r fs-14 ml-80 mt-5">{{ $t("xmsq.systemtip") }}</p>
      </div>
      <div class="float-l">
        <label style="width: 100px;">{{ $t("xmsq.queryFormbsqr") }}：</label>
        <input-multiple
          :placeholder="'Please select'"
          :multiple="true"
          :collapse-tags="true"
          :size="'small'"
          :value="ryvalue"
          :collapseTags="false"
          :filterable="true"
          @focus="handleFocus()"
          @clear="clear"
          :label="'xm'"
          :value-key="'xm'"
          clearable
        ></input-multiple>
      </div>
    </el-row>
    <el-row class="my-10">
      <!-- 时间选择 -->
      <div class="float-l py-5 text-a-l mr-20">
        <span class="">{{ $t("xmsq.queryFormqzrq") }}：</span>
        <el-date-picker
          v-model="value2"
          type="daterange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          :range-separator="$t('xmsq.to')"
          :start-placeholder="$t('xmsq.qsrq')"
          :end-placeholder="$t('xmsq.jzrq')"
          align="right"
          size="small"
          style="width:335px"
        >
        </el-date-picker>
      </div>
      <div class="py-5 ht-42 float-l">
        <div class="align-i-c ht-all">
          <div
            class="mr-20 min-wt-180"
            v-if="
              (showTyje.isShow || $store.state.sysCs.sfqy_tysqje == '1') &&
                btncolor != 'cx' &&
                btncolor != 'jp'
            "
          >
            <span class="fs-16 color-b">{{ $t("sqsq.sqje") }}：</span>
            <el-input
              v-model="tyBcsqje"
              placeholder="输入金额"
              size="small"
              class="wt-p-70"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="py-5 ht-42 lh-30 float-l">
        <div class="dy-flex">
          <div class="mr-20" v-if="showCqyx.isShow">
            <el-checkbox v-model="iscqyx" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.cqyx") }}</span>
            </el-checkbox>
          </div>
          <div
            class="mr-20"
            v-if="showKzje.isShow && btncolor != 'cx' && btncolor != 'jp'"
          >
            <el-checkbox v-model="kzjeall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.kzsqje") }}</span>
            </el-checkbox>
          </div>
          <div class="mr-20" v-if="showEcsq.isShow">
            <el-checkbox v-model="ecsqall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.ecsq") }}</span>
            </el-checkbox>
          </div>
          <div
            class="mr-20"
            v-if="showYeck.isShow && (btncolor == 'bx' || btncolor == 'all')"
          >
            <el-checkbox v-model="yeckall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.yeck") }}</span>
            </el-checkbox>
          </div>
          <div v-if="showMxz.isShow && btncolor == 'all'">
            <el-checkbox v-model="mxzall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.mxck") }}</span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <!-- 申请/重置 -->
      <div class="py-5 float-r mr-20">
        <el-button size="small" type="primary" @click="sqOperateWc">{{
          $t("xmsq.sqBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("xmsq.resetBtn")
        }}</el-button>
      </div>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        border
        stripe
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; font-size: 12px;"
        @cell-click="cellClick"
        @select="checkboxEvent"
        @select-all="selectionAll"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
        :max-height="$store.state.screenHeight - 295"
        :row-style="rowStyle"
      >
        <el-table-column
          type="selection"
          width="40"
          key="1"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="bmmc"
          :label="$t('xmsq.bmmc')"
          width="220px"
          align="center"
          header-align="center"
          v-if="tableColumnShow.bmmc"
        >
          <template slot-scope="scope">
            {{ scope.row.bmbh }} / {{ scope.row.bmmc }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmmc"
          :label="$t('xmsq.xmmc')"
          width="450px"
          align="center"
          header-align="center"
          v-if="tableColumnShow.xmmc"
        >
          <template #header>
            <p>
              <span class="mr-5">{{ $t("xmsq.xmmc") }}</span>
              <el-input
                v-model="searchPj"
                size="mini"
                :placeholder="$t('xmsq.searchPlaceholder')"
                style="width: 50%;"
              />
            </p>
          </template>
          <template slot-scope="scope">
            ({{ scope.row.xmbh }}) {{ scope.row.xmmc }} -- {{ scope.row.fzr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isecsq"
          :label="$t('xmsq.ecsq')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.isecsq"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isecsq"
              v-show="scope.row.isecsqinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.isecsqinp">{{
              scope.row.isecsq == "0" ? $t("xmsq.notallow") : $t("xmsq.allow")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcqsrq"
          :label="$t('xmsq.qsrq')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.wcqsrq"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcqsrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.qsrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcqsrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcjzrq"
          :label="$t('xmsq.jzrq')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.wcjzrq"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcjzrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.jzrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcjzrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="yeck"
          :label="$t('xmsq.yeck')"
          v-if="yeckshow && tableColumnShow.yeck"
          key="yeckshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.yeck"
              v-show="scope.row.yeckinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in yeckoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.yeckinp">{{
              scope.row.yeck == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mxzck"
          :label="$t('xmsq.mxck')"
          v-if="mxckshow && tableColumnShow.mxzck"
          key="mxckshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.mxzck"
              v-show="scope.row.mxckinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in mxckoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.mxckinp">{{
              scope.row.mxzck == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kzsqje"
          :label="$t('xmsq.kzsqje')"
          v-if="kzsqjeeshow && tableColumnShow.kzsqje"
          width="120px"
          key="kzsqjeeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.kzsqje"
              v-show="scope.row.kzsqjeinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in kzsqjeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.kzsqjeinp">{{
              scope.row.kzsqje == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bcsqje"
          :label="$t('xmsq.bcsqje')"
          v-if="bcsqjeshow && tableColumnShow.bcsqje"
          width="120px"
          key="bcsqjeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bcsqje"
              v-if="scope.row.bcsqjeinp"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="loseFcous(scope.$index, scope.row)"
            ></el-input>
            <span v-else>{{ jeFormat(scope.row.bcsqje, scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ysqje"
          :label="$t('xmsq.ysqje')"
          v-if="ysqjeshow && tableColumnShow.ysqje"
          key="ysqjeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span>{{ jeFormat(scope.row.ysqje) }}</span>
          </template></el-table-column
        >
        <el-table-column
          prop="yhfje"
          :label="$t('xmsq.yhfje')"
          v-if="yhfjeshow && tableColumnShow.yhfje"
          key="yhfjeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span>{{ jeFormat(scope.row.yhfje) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="xmsx"
          :label="$t('xmsq.xmsx')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.xmsx"
          :filters="[
            { text: $t('xmsq.public'), value: '2' },
            { text: $t('xmsq.personal'), value: '1' },
          ]"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            {{
              scope.row.xmsx == "1"
                ? $t("xmsq.personal")
                : scope.row.xmsx == "2"
                ? $t("xmsq.public")
                : ""
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 被授权人信息模态框 -->
    <xmsqry-dialog
      :title="$t('xmsq.xzbsqr')"
      :dialogbsqr="dialogbsqr"
      :tableData="ryxxData"
      :uniqueNum="'Y120101-1-2'"
      :cancelBtn="false"
      :confirmBtn="true"
      :confirmText="$t('common.confirmBtn')"
      :searchPlaceholder="$t('xmsq.dghhxmsx')"
      @confirm="confirm"
      @cancel="cancel"
      @searchFilter="searchFilter"
      @handleSelection="handleSelection"
      @selectionAll="selectionAllBsqr"
      v-if="xmsqryFlg"
    >
      <el-row slot="tableHead" class="pb-10">
        <el-select
          v-model="bmvalue"
          filterable
          :placeholder="$t('xmsq.qxzbm')"
          size="small"
          class="pr-10"
          @change="bmSelectChange"
        >
          <el-option
            v-for="item in bmOptions"
            :key="item.bmbh"
            :label="item.bmmc"
            :value="item.bmbh"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="showSelected()">{{
          btnText
        }}</el-button>
      </el-row>
      <el-row slot="page">
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>

    <xmsqry-dialog
      :title="$t('xmsq.xzbsqr')"
      :dialogbsqr="dialogbsqr2"
      :tableData="ryxxData"
      :uniqueNum="'Y120101-1-2'"
      :searchPlaceholder="$t('xmsq.dghhxmsx')"
      :cancelBtn="false"
      :confirmBtn="true"
      :confirmText="$t('common.confirmBtn')"
      @confirm="confirm"
      @cancel="cancel"
      @searchFilter="searchFilter"
      @handleSelection="handleSelection"
      @selectionAll="selectionAllBsqr"
      v-if="xmsqryFlg"
    >
      <el-row slot="tableHead" class="pb-10">
        <InputBox
          :id="'bsqr'"
          class=""
          :uniqueNum="uniqueNum"
          :suffixicon="'el-icon-search'"
          @contentChange="contentChange"
          @suffixIconClick="suffixIconClick"
          :inputData="getArgumentDetail('bsqrTil')"
          :clearable="true"
          @inputClear="clearBsqr"
        >
        </InputBox>
        <el-button
          class="ml-10"
          type="primary"
          size="small"
          @click="suffixIconClick()"
          >{{ $t("common.searchBtn") }}
        </el-button>
        <el-button
          class="ml-10"
          type="primary"
          size="small"
          @click="showSelected()"
          >{{ btnText }}
        </el-button>
      </el-row>
      <!-- 分页组件 -->
      <el-row slot="page">
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqgl";
// import * as sqgl from "@/api/qhsqgl";
import InputMultiple from "@/components/InputMultiple.vue";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";
import dateFormat from "@/utils/dateFormat";

export default {
  // 项目授权
  name: "xmsq",
  components: {
    InputMultiple,
    XmsqryDialog,
  },
  computed: {},
  watch: {
    value2: {
      handler: function(newVal, oldVal) {
        if (newVal == null) {
          newVal = [];
        }
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].wcqsrq = newVal[0];
          this.tableData[item.index].wcjzrq = newVal[1];
        });
      },
      deep: true, // 开启深度监听
    },
    kzjeall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          let data = this.tableData[item.index];
          data.kzsqje = newVal ? "1" : "0";
          data.bcsqje = newVal
            ? this.tyBcsqje == ""
              ? data.ye
              : this.tyBcsqje
            : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    ecsqall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].isecsq = newVal ? "1" : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    mxzall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].mxzck = newVal ? "1" : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    yeckall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].yeck = newVal ? "1" : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    tyBcsqje: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].bcsqje = newVal;
        });
      },
      deep: true, // 开启深度监听
    },
    iscqyx: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          const end = new Date("2050-12-31");
          const start = new Date();
          // end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
          this.value2 = [
            dateFormat.format(start, "yyyy-MM-dd"),
            dateFormat.format(end, "yyyy-MM-dd"),
          ];
        } else {
          this.value2 = [];
        }
      },
      dreep: true,
    },
  },
  data() {
    return {
      btnText: this.$t("xmsq.yxzry"),
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      btncolor: "",
      tableKey: 0,
      queryForm: {
        system: "",
        bsqrzjh: "",
        xm: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("xmsq.onemonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.threemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.sixmonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.cqyx"),
            onClick(picker) {
              const end = new Date("2050-12-31");
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      options: [
        {
          value: "1",
          label: this.$t("xmsq.allow"),
        },
        {
          value: "0",
          label: this.$t("xmsq.notallow"),
        },
      ],
      yeckoptions: [
        {
          value: "1",
          label: this.$t("xmsq.shi"),
        },
        {
          value: "0",
          label: this.$t("xmsq.fou"),
        },
      ],
      mxckoptions: [
        {
          value: "1",
          label: this.$t("xmsq.shi"),
        },
        {
          value: "0",
          label: this.$t("xmsq.fou"),
        },
      ],
      kzsqjeoptions: [
        {
          value: "1",
          label: this.$t("xmsq.shi"),
        },
        {
          value: "0",
          label: this.$t("xmsq.fou"),
        },
      ],
      yhbhoryhmc: "",
      multipleSelection: [],
      selectScope: [],
      value2: [],
      kzjeall: true,
      ecsqall: this.$store.state.sysCs.defaultEcsq != "0",
      mxzall: true,
      yeckall: true,
      iscqyx: false,
      tyBcsqje: "",
      yeckshow: false,
      mxckshow: false,
      kzsqjeeshow: false,
      bcsqjeshow: false,
      ysqjeshow: false,
      yhfjeshow: false,
      tableData: [],
      tabLoading: false, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      screenHeight: "0",
      dialogbsqr: false,
      dialogbsqr2: false,
      ryxxDataAll: [],
      activeTableData: [],
      ryxxData: [],
      uniqueNum: "Y120101-1-1",
      value: [],
      yhxx: this.$store.state.yhxx.yhxx,
      ryvalue: [],
      bmOptions: [],
      bmvalue: "",
      searchData: [],
      search: "",
      searchPj: "",
      xmsqryFlg: true,
      isqfxt: true,
      bsqr: "",
      argumentDetail: {},
      argumentConfig: {
        bsqrTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "input-bsqr",
        },
        wscxbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-wcxt",
        },
        wsbxbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-bxxt",
        },
        wssbbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-sbxt",
        },
        yjkpbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-jpxt",
        },
        settyje: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-tyje",
        },
        setyeck: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-yeck",
        },
        setcqyx: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-cqyx",
        },
        setecsq: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-ecsq",
        },
        setkzje: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-kzje",
        },
        setmxz: {
          moduleId: "1",
          groupId: "1",
          fieldId: "set-mxz",
        },
      },
      tableColumns: [],
      tableColumnShow: {},
      showCqyx: {
        isShow: true,
      },
      showEcsq: {
        isShow: true,
      },
      showTyje: {
        isShow: false,
      },
      showYeck: {
        isShow: true,
      },
      showKzje: {
        isShow: true,
      },
      showMxz: {
        isShow: true,
      },
    };
  },
  methods: {
    // 项目授权过滤
    rowStyle(val) {
      let row = val.row;
      if (this.searchPj == "") {
        return;
      } else {
        if (
          row.xmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          row.xmbh.toLowerCase().includes(this.searchPj.toLowerCase())
          // row.bmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          // row.bmbh.toLowerCase().includes(this.searchPj.toLowerCase())
        ) {
          return;
        } else {
          return {
            display: "none",
          };
        }
      }
    },
    // 根据部门编号查询被授权人
    getSysUserByBmbh(bmbh) {
      yhxx.getSysUserByBmbh({ bmbh: bmbh }).then((res) => {
        this.ryxxDataAll = res.data.data;
        this.activeTableData = this.ryxxDataAll;
        this.dataPaging(this.ryxxDataAll);
      });
    },
    // 被授权人数据分页
    dataPaging(activeTableData) {
      this.ryxxData = [];
      if (activeTableData) {
        this.total = activeTableData.length;
        if (activeTableData.length <= (this.currentPage - 1) * this.limit) {
          this.currentPage = 1;
        }
        let i = (this.currentPage - 1) * this.limit;
        for (
          i;
          i < this.currentPage * this.limit && i < activeTableData.length;
          i++
        ) {
          this.ryxxData.push(activeTableData[i]);
        }
      }
    },
    // 显示已选择被授权人数据
    showSelected() {
      this.searchData = [];
      this.currentPage = 1;
      this.limit = this.$store.state.dataDisplayNum;
      if (this.btnText == this.$t("xmsq.yxzry")) {
        this.activeTableData = this.ryvalue;
        this.btnText = this.$t("xmsq.jxxzry");
        if (this.search) {
          this.searchFilter(this.search);
        } else {
          this.dataPaging(this.ryvalue);
        }
      } else if (this.btnText == this.$t("xmsq.jxxzry")) {
        this.activeTableData = this.ryxxDataAll;
        this.btnText = this.$t("xmsq.yxzry");
        // this.dataPaging(this.ryxxDataAll);
        if (this.search) {
          this.searchFilter(this.search);
        } else {
          this.dataPaging(this.ryxxDataAll);
        }
      }
    },
    // 获取部门信息
    getBmxxList() {
      this.bmvalue = this.yhxx.gzbmbh;
      if (this.bmvalue != null && this.bmvalue != "") {
        this.getSysUserByBmbh(this.bmvalue);
      }

      yhxx.getBmxxList().then((res) => {
        this.bmOptions = res.data.data;
      });
    },
    // 部门变化方法
    bmSelectChange(bmbh) {
      this.getSysUserByBmbh(bmbh);
    },
    // 被授权人筛选方法
    searchFilter(search) {
      this.search = search;
      if (search) {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        let data = [];
        this.activeTableData.filter((item) => {
          if (
            item.xm.toLowerCase().includes(search.toLowerCase()) ||
            item.rydm.toLowerCase().includes(search.toLowerCase()) ||
            item.bmmc.toLowerCase().includes(search.toLowerCase())
          ) {
            data.push(item);
          }
        });
        this.searchData = this.activeTableData;
        this.activeTableData = data;
        this.dataPaging(data);
      } else {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        this.dataPaging(this.activeTableData);
        this.searchData = [];
      }
    },
    contentChange(val) {
      this.bsqr = val;
    },
    // 清空项目人员
    clearBsqr() {
      this.getSysUserByBmbh(this.bmvalue);
      this.rydm = null;
    },
    // 查询项目人员
    suffixIconClick() {
      let arr = [];
      if (this.bsqr != null && this.bsqr != "") {
        yhxx.getSysUser({ rydm: this.bsqr }).then((res) => {
          let res1 = res.data.data;
          arr = res1.ryxx;
          switch (res1.ryxx.length) {
            case 0:
              this.ryxxDataAll = res.data.data.ryxx;
              this.activeTableData = this.ryxxDataAll;
              this.dataPaging(this.ryxxDataAll);
              break;
            default:
              this.ryxxDataAll = res.data.data.ryxx;
              this.activeTableData = this.ryxxDataAll;
              this.dataPaging(this.ryxxDataAll);
              break;
          }
        });
      } else {
        this.getSysUserByBmbh(this.bmvalue);
        this.rydm = null;
      }
    },
    // 项目属性筛选方法
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 表格选中状态改变时方法
    handleSelection(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      this.ryvalue = selection;
    },
    // 表格点击全选时方法
    selectionAllBsqr(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      this.ryvalue = selection;
    },

    // 表格点击全选时方法
    selectionAll(selection) {
      this.multipleSelection = [];
      this.selectScope = selection;
      if (this.value2.length > 0) {
        selection.forEach((item) => {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
          if (this.kzje != "") {
            item.kzsqje = this.kzje;
          }
        });
      }
      this.multipleSelection = selection;
    },
    // 选中状态改变
    losechange(index, row) {
      if (row.kzsqje == "0" && row.bcsqje > "0.00") {
        this.tableData[index].bcsqje = "0";
      }
      if (row.kzsqje == "1" && row.bcsqje <= "0.00") {
        this.tableData[index].bcsqje = row.ye;
      }
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.mxckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    // 失去焦点
    loseFcous(index, row) {
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.mxckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    // 单击单元格方法
    cellClick(row, column, cell, event) {
      if (column.property === "isecsq") {
        if (row.fzrbh == this.yhxx.ygbh) {
          row.isecsqinp = true;
          this.$nextTick(() => {
            let inp =
              cell.firstElementChild.firstElementChild.firstElementChild;
            inp.click();
          });
        }
      } else if (column.property === "wcqsrq") {
        row.qsrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "wcjzrq") {
        row.jzrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "yeck") {
        row.yeckinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "mxzck") {
        row.mxckinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "kzsqje") {
        row.kzsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "bcsqje") {
        row.bcsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      }
    },
    // 选择表格方法
    checkboxEvent(scope, row) {
      this.selectScope = scope;
      row.qssj = "";
      row.jzsj = "";
      let v = this.value2.length > 0;
      scope.forEach((item) => {
        if (v) {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
        }
        item.kzsqje = this.kzjeall ? "1" : "0";
        item.isecsq = this.ecsqall ? "1" : "0";
        item.mxzck = this.mxzall ? "1" : "0";
        item.yeck = this.yeckall ? "1" : "0";
        item.bcsqje = this.kzjeall
          ? this.tyBcsqje == ""
            ? item.ye
            : this.tyBcsqje
          : "0";
      });
    },
    // 选择状态改变时方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 网查授权项目
    getXmsqinfo(system) {
      let _this = this;
      _this.btncolor = system;
      if (system == "cx") {
        _this.yeckshow = false;
        _this.mxckshow = false;
        _this.kzsqjeeshow = false;
        _this.bcsqjeshow = false;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      } else if (system == "bx") {
        _this.yeckshow = true;
        _this.mxckshow = false;
        _this.kzsqjeeshow = true;
        _this.bcsqjeshow = true;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      } else if (system == "sb") {
        _this.yeckshow = false;
        _this.mxckshow = false;
        _this.kzsqjeeshow = true;
        _this.bcsqjeshow = true;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      } else if (system == "jp") {
        _this.yeckshow = false;
        _this.mxckshow = false;
        _this.kzsqjeeshow = false;
        _this.bcsqjeshow = false;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      } else if (system == "all") {
        _this.yeckshow = true;
        _this.mxckshow = true;
        _this.kzsqjeeshow = true;
        _this.bcsqjeshow = true;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      }
      _this.queryForm.system = system;
      _this.tableData = [];
      _this.tabLoading = true; // 关闭请求时的loading层
      if (system == "all") {
        sqgl
          .getXmsqinfo2(_this.queryForm)
          .then((res) => {
            _this.tabLoading = false; // 关闭请求时的loading层
            if (res.data.code == "200") {
              res.data.data.forEach((item, index) => {
                item.yeck = "1";
                item.mxzck = "1";
                item.kzsqje = "1";
                item.wcqsrq = "";
                item.wcjzrq = "";
                item.index = index;
              });
              _this.tableData = res.data.data;
            }
          })
          .catch((error) => {
            _this.tabLoading = false; // 关闭请求时的loading层
          });
      } else {
        sqgl
          .getXmsqinfo(_this.queryForm)
          .then((res) => {
            _this.tabLoading = false; // 关闭请求时的loading层
            if (res.data.code == "200") {
              res.data.data.forEach((item, index) => {
                item.yeck = "1";
                item.mxzck = "1";
                item.kzsqje = "1";
                item.wcqsrq = "";
                item.wcjzrq = "";
                item.index = index;
              });
              _this.tableData = res.data.data;
            }
          })
          .catch((error) => {
            _this.tabLoading = false; // 关闭请求时的loading层
          });
      }
    },

    // 金额格式化
    jeFormat(je, row) {
      if (je == null || je == undefined) {
        je = "0";
      }
      let j = this.$comUtils.moneyFormat(je);
      if (je.replace(/,/g, "") != j.replace(/,/g, "")) {
        row.bcsqje = j;
      }
      return j;
    },

    // 授权确认操作
    sqOperateWc() {
      let _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      let dqDate = yy + "-" + mm + "-" + dd;
      let ok = true;
      let tsxx = "";
      if (_this.multipleSelection.length == 0) {
        _this.$message.error(_this.$t("xmsq.qxzsqxm"));
        return false;
      } else if (_this.ryvalue.length == 0) {
        _this.$message.error(_this.$t("xmsq.qsrbsqr"));
        return false;
      }
      for (let i = 0; i < _this.multipleSelection.length; i++) {
        // if (_this.multipleSelection[i].isecsq == "0"){
        //     _this.$message.error('"('+_this.multipleSelection[i].xmbh+')'+_this.multipleSelection[i].xmmc+'"'+_this.$t('xmsq.notallowecsq'));
        //     return false;
        // }else
        if (
          _this.multipleSelection[i].wcqsrq == "" ||
          _this.multipleSelection[i].wcjzrq == ""
        ) {
          _this.$message.error(
            "“(" +
              _this.multipleSelection[i].xmbh +
              ")" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.rqtxbwz")
          );
          return false;
        } else if (_this.multipleSelection[i].wcqsrq < dqDate) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.qsrqxydqrq")
          );
          return false;
        } else if (
          _this.multipleSelection[i].jzrq &&
          _this.multipleSelection[i].jzrq != null &&
          _this.multipleSelection[i].jzrq != "" &&
          _this.multipleSelection[i].wcjzrq > _this.multipleSelection[i].jzrq
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.jzrqdyqxjzrq") +
              "[" +
              _this.multipleSelection[i].jzrq +
              "]"
          );
          return false;
        } else if (
          _this.multipleSelection[i].wcqsrq > _this.multipleSelection[i].wcjzrq
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.jzrqdyqsrq")
          );
          return false;
        } else if (
          _this.multipleSelection[i].kzsqje == "1" &&
          _this.multipleSelection[i].bcsqje <= 0 &&
          _this.btncolor != "cx" &&
          _this.btncolor != "jp"
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.bcsqjexdy0")
          );
          return false;
        } else if (_this.multipleSelection[i].kzsqje == "0") {
          _this.multipleSelection[i].bcsqje = "";
        } else {
          if (_this.multipleSelection[i].bcsqje) {
            _this.multipleSelection[i].bcsqje = _this.multipleSelection[
              i
            ].bcsqje.replace(/,/g, "");
          }
          let sqje = parseFloat(_this.multipleSelection[i].bcsqje);
          // _this.multipleSelection[i].bcsqje = sqje;
          let ye = parseFloat(_this.multipleSelection[i].ye);
          if (sqje >= ye) {
            tsxx =
              "项目（" +
              _this.multipleSelection[i].xmbh +
              "/" +
              _this.multipleSelection[i].xmmc +
              "）的授权金额已超过项目余额（" +
              _this.multipleSelection[i].ye +
              "）";
            if (_this.yhxx.ygbh === _this.multipleSelection[i].fzrbh) {
              if (sqje > ye) {
                ok = false;
              }
            } else if (_this.multipleSelection[i].kzje != "0") {
              if (sqje === ye) {
                _this.$message.error(
                  "二次授权时，授权金额不能等于剩余金额（" +
                    _this.multipleSelection[i].ye +
                    "）"
                );
                // ok = false;
                return false;
              } else {
                _this.$message.error(
                  "二次授权时，授权金额不能超过剩余金额（" +
                    _this.multipleSelection[i].ye +
                    "）"
                );
                // ok = false;
                return false;
              }
            }
          }
        }
      }
      if (ok) {
        _this
          .$confirm(
            _this.$t("xmsq.Confirmauthorization"),
            _this.$t("xmsq.Confirmationinformation"),
            {
              distinguishCancelAndClose: true,
              confirmButtonText: _this.$t("common.confirmBtn"),
              cancelButtonText: _this.$t("common.cancelBtn"),
            }
          )
          .then((res1) => {
            let data = {};
            let xmList = [];
            let bsqrzjhList = [];
            _this.ryvalue.forEach((item) => {
              bsqrzjhList.push(item.rydm);
              xmList.push(item.xm);
            });
            data.systemType = _this.queryForm.system;
            data.dataList = _this.multipleSelection;
            data.bsqrzjhList = bsqrzjhList;
            data.xmList = xmList;
            if (_this.btncolor == "all") {
              _this.spOperatess(data);
            } else {
              _this.spOperates(data);
            }
          })
          .catch((action) => {});
      } else {
        _this
          .$confirm(tsxx, "提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: "继续授权",
            cancelButtonText: "取消授权",
            type: "warning",
            center: true,
          })
          .then(() => {
            let data = {};
            let xmList = [];
            let bsqrzjhList = [];
            _this.ryvalue.forEach((item) => {
              bsqrzjhList.push(item.rydm);
              xmList.push(item.xm);
            });
            data.systemType = _this.queryForm.system;
            data.dataList = _this.multipleSelection;
            data.bsqrzjhList = bsqrzjhList;
            data.xmList = xmList;
            if (_this.btncolor == "all") {
              _this.spOperatess(data);
            } else {
              _this.spOperates(data);
            }
          })
          .catch(() => {});
      }
    },

    // 批量授权操作（区分系统）
    spOperates(data) {
      this.tabLoading = true;
      sqgl
        .spOperates(data)
        .then((res) => {
          if (res.data.code == "200") {
            this.resetSearch();
            this.getXmsqinfo(this.queryForm.system);
            this.$message.success(this.$t("xmsq.CzSuccess"));
          } else {
            this.tabLoading = false;
          }
        })
        .catch(() => {
          this.tabLoading = false;
        });
    },

    // 批量授权操作（不区分系统）
    spOperatess(data) {
      this.tabLoading = true;
      sqgl
        .spOperatess(data)
        .then((res) => {
          if (res.data.code == "200") {
            this.resetSearch();
            this.getXmsqinfo("all");
            this.$message.success(this.$t("xmsq.CzSuccess"));
          } else {
            this.tabLoading = false;
          }
        })
        .catch(() => {
          this.tabLoading = false;
        });
    },

    /** 重置操作 */
    resetSearch(typeFlg) {
      this.yhbhoryhmc = "";
      this.clear();
      this.btncolor = "";
      this.tableData = [];
      this.kzjeall = true;
      this.ecsqall = this.$store.state.sysCs.defaultEcsq != "0";
      this.mxzall = true;
      this.yeckall = true;
      this.iscqyx = false;
      this.tyBcsqje = "";
      this.multipleSelection = [];
      // this.$refs.yhbhoryhmc2.innerHTML = "";
      // this.value2 = [];
    },
    // 被授权人框获得焦点方法
    handleFocus(event) {
      if (
        this.$store.state.sysCs.xmsqbsqr_bm &&
        this.$store.state.sysCs.xmsqbsqr_bm == "1"
      ) {
        this.dialogbsqr2 = true;
      } else {
        this.dialogbsqr = true;
      }
    },
    // 选择人员确认
    confirm(ryxx) {
      this.ryvalue = ryxx;
      this.dialogbsqr = false;
      this.dialogbsqr2 = false;
    },
    // 取消选择人员
    cancel() {
      this.dialogbsqr = false;
      this.dialogbsqr2 = false;
      this.activeTableData = this.ryxxDataAll;
      this.dataPaging(this.ryxxDataAll);
      this.btnText = "已选择人员";
    },
    // 清空选择框
    clear() {
      this.xmsqryFlg = false;
      this.ryvalue = [];
      this.$nextTick(() => {
        this.xmsqryFlg = true;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.dataPaging(this.activeTableData);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.dataPaging(this.activeTableData);
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120101",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
        let tyje = _this.getArgumentDetail("settyje");
        let cqyx = _this.getArgumentDetail("setcqyx");
        let ecsq = _this.getArgumentDetail("setecsq");
        let kzje = _this.getArgumentDetail("setkzje");
        let yeck = _this.getArgumentDetail("setyeck");
        let mxz = _this.getArgumentDetail("setmxz");
        _this.showTyje.isShow = tyje
          ? tyje.isShow == "1"
          : _this.showTyje.isShow;
        _this.showCqyx.isShow = cqyx
          ? cqyx.isShow == "1"
          : _this.showCqyx.isShow;
        _this.showEcsq.isShow = ecsq
          ? ecsq.isShow == "1"
          : _this.showEcsq.isShow;
        _this.showKzje.isShow = kzje
          ? kzje.isShow == "1"
          : _this.showKzje.isShow;
        _this.showYeck.isShow = yeck
          ? yeck.isShow == "1"
          : _this.showYeck.isShow;
        _this.showMxz.isShow = mxz ? mxz.isShow == "1" : _this.showMxz.isShow;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      this.tabLoading = true;
      let params = {};
      params.pageId = "Y120101";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil
        .getXtTableConfig(params)
        .then((tmpResult) => {
          this.tableColumns = tmpResult;
          let shows = {};
          this.tableColumns.forEach((item) => {
            if (item.columnKey != "xzk") {
              shows[item.columnKey] = item.isShow == "1" ? true : false;
            }
          });
          this.tableColumnShow = shows;
          this.tabLoading = false;
        })
        .catch((err) => {
          this.tabLoading = false;
        });
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.suffixIconClick();
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
    let qfxt_ProjectAuz = this.$store.state.sysCs.qfxt_ProjectAuz;
    this.isqfxt =
      qfxt_ProjectAuz == null ||
      qfxt_ProjectAuz == undefined ||
      qfxt_ProjectAuz === "1";
    if (!this.isqfxt) {
      this.getXmsqinfo("all");
    }
    this.loadQueryConfig();
    this.getPageTableConfig();
    this.getBmxxList();
  },
  destroyed: function() {
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>
<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}

::v-deep .el-checkbox__label {
  display: inline-block;
  padding-left: 5px;
  line-height: 19px;
  font-size: 14px;
}
/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 50px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}

::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 70px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
.min-wt-480 {
  min-width: 480px;
}
</style>
